import { useEffect, useState, useRef } from 'react'
import { Link } from 'react-router-dom'
import { useReactToPrint } from 'react-to-print'
import { LocalStorage } from '../../services/localStorage/LocalStorage.services'
import { Popover } from 'antd'
import { DatePicker } from 'antd'

import Button from '../../components/UI/Button'
import Filter from '../../components/Filter/Filter'

import getAllTasks from '../../services/tasks/getAllTasks'
import getAllTasksByUserId from '../../services/tasks/getAllTasksByUserId'
import desactiveTasks from '../../services/tasks/desactiveTasks'
import getAllTipus from '../../services/tipus/getAllTipus'
import getAllArees from '../../services/arees/getAllArees'
import getAllLabels from '../../services/labels/getAllLabels'
import getAllProfessionals from '../../services/professionals/getAllProfessionals'

import styles from './Tasks.module.css'

const Seguiments = () => {

  const componentRef = useRef()

  const [ pageSize, setPageSize ] = useState(20)
  const [ currentPage, setCurrentPage ] = useState(1)
  const [ numberOfPages, setNumberOfPages ] = useState(0)
  const [ currentDataDisplayed, setCurrentDataDisplayed ] = useState([])
  const [ previousAllowed, setPreviousAllowed ] = useState(false)
  const [ nextAllowed, setNextAllowed ] = useState(true)
  const [ isChecked, setIsChecked ] = useState([])

  const [ tasks, setTasks ] = useState([])
  const [ tasksFiltered, setTasksFiltered ] = useState([])
  const [ tasksFiltered1, setTasksFiltered1 ] = useState([])
  const [ tasksFiltered2, setTasksFiltered2 ] = useState([])
  const [ tasksFiltered3, setTasksFiltered3 ] = useState([])
  const [ tasksFiltered4, setTasksFiltered4 ] = useState([])
  const [ tasksFiltered5, setTasksFiltered5 ] = useState([])
  const [ tasksFiltered6, setTasksFiltered6 ] = useState([])
  const [ professionals, setProfessionals ] = useState([])
  const [ tipus, setTipus ] = useState([])
  const [ arees, setArees ] = useState([])
  const [ labels, setLabels ] = useState([])
  const [ update, setUpdate ] = useState(false)
  const [ visible, setVisible ] = useState(false)

  useEffect(() => {
    if (LocalStorage.getItem("professionalProfile") === "Superadministrador" || LocalStorage.getItem("professionalProfile") === "Administrador") {
      getAllTasks()
      .then(tasks => {
        setTasks(tasks)
        setTasksFiltered(tasks)
        setTasksFiltered1(tasks)
        setTasksFiltered2(tasks)
        setTasksFiltered3(tasks)
        setTasksFiltered4(tasks)
        setTasksFiltered5(tasks)
        setTasksFiltered6(tasks)
      })
    } else {
      getAllTasksByUserId(LocalStorage.getItem("id"))
      .then(tasks => {
        setTasks(tasks)
        setTasksFiltered(tasks)
        setTasksFiltered1(tasks)
        setTasksFiltered2(tasks)
        setTasksFiltered3(tasks)
        setTasksFiltered4(tasks)
        setTasksFiltered5(tasks)
        setTasksFiltered6(tasks)
      })
    }
    getAllProfessionals()
    .then(elements => {
      if (LocalStorage.getItem("professionalProfile") !== "Superadministrador") {
        const professionalAuth = elements.filter( element => element.professionalProfile !== "Superadministrador" &&  element.professionalProfile !== "Bot" )
        setProfessionals(professionalAuth)
      } else {
        setProfessionals(elements)
      }
    })
    getAllTipus()
    .then(elements => {
      setTipus(elements)
    })
    getAllArees()
    .then(elements => {
      setArees(elements)
    })
    getAllLabels()
    .then(elements => {
      setLabels(elements)
    })
  },[update])

  useEffect(() => {
    tasksFiltered &&
      setCurrentDataDisplayed(() => {
        const page = tasksFiltered?.slice((currentPage - 1) * pageSize, currentPage * pageSize)
        return page
      })
      setIsChecked(() => {
        const page = tasksFiltered?.slice((currentPage - 1) * pageSize, currentPage * pageSize)
        return (new Array(page.length).fill(false))
      })
      setPreviousAllowed(() => currentPage > 1)
      setNextAllowed(() => currentPage < numberOfPages)
      setNumberOfPages(Math.ceil(tasksFiltered.length / pageSize))
  }, [currentPage, tasksFiltered, pageSize, update, numberOfPages])

  // Actualizar els seguimients filtrats combinant ambdos filtres
  useEffect(() => {
    const uniqueValues = getCommonValues(tasksFiltered1, tasksFiltered2, tasksFiltered3, tasksFiltered4, tasksFiltered5, tasksFiltered6)
    setTasksFiltered(uniqueValues)
  }, [tasksFiltered1, tasksFiltered2, tasksFiltered3, tasksFiltered4, tasksFiltered5, tasksFiltered6])

  const handlePagination = (action) => {
    if (action === "prev") {
      if (!previousAllowed) return
      setCurrentPage((prevState) => (prevState -= 1))
    }
    if (action === "next") {
      if (!nextAllowed) return
      setCurrentPage((prevState) => (prevState += 1))
    }
  }

  const handleDesactiveMultiple = (event) => {
    const arrayId = []
    for (let index = 0; index < isChecked.length; index++) {
      arrayId[index] = currentDataDisplayed[index]._id
    }
    for (let index = 0; index < isChecked.length; index++) {
      isChecked[index] && desactiveTasks(arrayId[index])
    }
    setUpdate(!update)
  }

  // Función para canviar la paginación de la tabla
  const handleChangePageSize = (event) => {
    setPageSize(parseInt(event.target.value))
  }

  const handleDesactive = (event) => {
    desactiveTasks(event.target.parentNode.parentNode.id)
    setUpdate(!update)
  }

  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    documentTitle: "Taula de tasques",
    onafterprint: () => alert('Print success')
  })
  
  const titles = [ "", "Tasca", "Assignada", "Projecte", "Etiquetes", "Tipus", "Planificat", "Realitzat", "Estat", "Accions" ]

  function getCommonValues(...arrays) {
    return arrays.reduce((acc, currentArray) => {
      return acc.filter((value) => currentArray.includes(value))
    })
  }

  // Función para hacer funcionar el filtro de elementos => por tasca
  const handleChangeTask = (value) => {
    if (value.length !== 0) {
      let tasksFiltereds = tasks.filter(element => value.includes(element._id)) 
      setTasksFiltered5(tasksFiltereds)
    } else {
      setTasksFiltered5(tasks)
    }
  } 

  // Placeholder del filtro de tasca
  const placeholderFilterTask = "Filtre tasques"

  // Array con los elementos del filtro de tasca
  const dataTask = tasks.map(element => {
    return {
      label: `${element.taskDescription}`,
      value: element._id
    }
  })

  // Función para hacer funcionar el filtro de elementos => por projecte
  const handleChangeProjecte = (value) => {
    if (value.length !== 0) {
      let tasksFiltereds = tasks.filter(element => value.includes(element.taskAreaId._id)) 
      setTasksFiltered1(tasksFiltereds)
    } else {
      setTasksFiltered1(tasks)
    }
  } 

  // Placeholder del filtro de projecte
  const placeholderFilterProjecte = "Filtre projecte"

  // Array con los elementos del filtro de projecte
  const dataProjecte = arees.map(element => {
    return {
      label: `${element.areaName}`,
      value: element._id
    }
  })

  // Función para hacer funcionar el filtro de elementos => por professional
  const handleChangeProfessional = (value) => {
    if (value.length !== 0) {
      let tasksFiltereds = tasks.filter(element => value.includes(element?.taskProfessionalId?._id)) 
      setTasksFiltered2(tasksFiltereds)
    } else {
      setTasksFiltered2(tasks)
    }
  }

  // Placeholder del filtro de professional
  const placeholderFilterProfessional = "Filtre professional"

  // Array con los elementos del filtro de professional
  const dataProfessional = professionals.map(element => {
    return {
      label: `${element.professionalName} ${element.professionalLastName1} ${element.professionalLastName2}`,
      value: element._id
    }
  })
  
  // Función para hacer funcionar el filtro de elementos => por etiquetes
  const handleChangeLabels = (value) => {
    if (value.length !== 0) {
      let tasksFiltereds = tasks.filter(element => element.taskLabelId.some(label => value.includes(label._id)))
      setTasksFiltered3(tasksFiltereds)
    } else {
      setTasksFiltered3(tasks)
    }
  }

  // Placeholder del filtro de tipus de etiquetes
  const placeholderFilterLabels = "Filtre d'etiqueta"

  // Array con los elementos del filtro de tipus de competencia
  const dataLabels = labels.map(element => {
    return {
      label: `${element.labelName}`,
      value: element._id
    }
  })

  // Función para hacer funcionar el filtro de elementos => por estat
  const handleChangeState = (value) => {
    if (value.length !== 0) {
      let tasksFiltereds = tasks.filter(element => value.includes(element.taskStatus))
      setTasksFiltered4(tasksFiltereds)
    } else {
      setTasksFiltered4(tasks)
    }
  }

  // Placeholder del filtro de estat
  const placeholderStatus = "Filtre estat tasca"

  // Array con los elementos del filtro de estat
  const dataStatus = [
    {
      label: "Pendent",
      value: true,
    },
    {
      label: "Realitzat",
      value: false,
    },
  ]

  // Función para hacer funcionar el filtro de elementos => por data
  const handleChangeDate = (dateString) => {
    const date = new Date(dateString).toDateString()
    const value = [date]
    if (value[0] !== 'Thu Jan 01 1970') {
      let tasksFiltereds = tasks.filter(element => {
        const date = new Date(element.taskPlanningDate).toDateString()
        return value.includes(date)
      }) 
      setTasksFiltered6(tasksFiltereds)
    } else {
      setTasksFiltered6(tasks)
    }
  }

  const handelSelectedTasks = (position) => {
    const updatedCheckedState = isChecked.map((item, index) =>
      index === position ? !item : item
    )
    setIsChecked(updatedCheckedState)
  }
  
  const handelSelectedAllTasks = (event) => {
    const newValues = []
    if (event.target.checked === true) {
      for (let index = 0; index < isChecked.length; index++) {
        newValues[index] = true
      }
    } else {
      for (let index = 0; index < isChecked.length; index++) {
        newValues[index] = false
      }
    }
    setIsChecked(newValues)
  }

  // Funció per truncar el text
  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
        return text.substring(0, maxLength) + '...'
    }
    return text
  }

  const handleVisible = () => {
    setVisible(!visible)
  }

  return (
    <div className={styles.container}>
      <div className={styles.main}>
        <div onClick={handleVisible} className={styles.icons}>
          {visible ? <i class="fa-solid fa-eye-slash"></i> : <i onClick={handleVisible} class="fa-solid fa-eye"></i>}
        </div>
        <div className={visible ? styles.filters : styles.disable}>
          <div className={styles.multiselector}>
            <Filter
              data={dataTask} 
              handleChange={handleChangeTask}
              placeholderFilter={placeholderFilterTask}
              type='multiple'
            />
          </div>
          <div className={styles.multiselector}>
            <Filter
              data={dataProjecte} 
              handleChange={handleChangeProjecte}
              placeholderFilter={placeholderFilterProjecte}
              type='multiple'
            />
          </div>
          <div className={styles.multiselector}>
            <Filter
              data={dataProfessional} 
              handleChange={handleChangeProfessional}
              placeholderFilter={placeholderFilterProfessional}
              value={LocalStorage.getItem("id")}
              type='multiple'
            />
          </div>
          <div className={styles.multiselector}>
            <Filter
              data={dataLabels} 
              handleChange={handleChangeLabels}
              placeholderFilter={placeholderFilterLabels}
              type='multiple'
            />
          </div>
          <div className={styles.multiselector}>
            <Filter
              data={dataStatus} 
              handleChange={handleChangeState}
              placeholderFilter={placeholderStatus}
              type='multiple'
            />
          </div>
          <div className={styles.multiselector}>
            <DatePicker 
              onChange={handleChangeDate} 
              className={styles.datapicker} 
              placeholder='Filtre data planificació'
            />
          </div>
        </div>
        <div className={styles.button}>
          <div className={styles.pagination}>
            <button onClick={() => handlePagination("prev")}><i className="fa-solid fa-backward"></i></button>
            <button onClick={() => handlePagination("next")}><i className="fa-solid fa-forward"></i></button>
            <p>
              <span>{pageSize * (currentPage - 1)}</span> a <span>{currentDataDisplayed && currentDataDisplayed.length+(currentPage - 1) * pageSize}</span> de <span>{tasksFiltered?.length}</span> resultats
            </p>
            <div className={styles.view}>
              <span>Mostrar </span>
              <select onChange={handleChangePageSize} value={pageSize}>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>
              <span> resultats</span>
            </div>
          </div>
          <div className={styles.buttons}>
            <Button handleOnClick={handlePrint} icon={"fa-print"}/>
            <Button handleOnClick={handleDesactiveMultiple} icon={"fa-trash"}/>
            <Button path="/tasques/new-tasca" icon={"fa-circle-plus"}/>
          </div>
        </div>
      </div>
      <div className={styles.listElements} ref={componentRef}>
        <div className={styles.taskslist}>
          {currentDataDisplayed
            ? currentDataDisplayed.map((element, index) => {
              const url = '/tasques/' + element._id
              const url2 = '/accions'
              let checkedItem = isChecked[index]
              return (
                <div className={element.taskDoDate ? styles.taskDo : styles.taskPending} id={element._id} key={element._id}>
                  <div>
                    <input type='checkbox' id={index} value={element._id} checked={checkedItem} onChange={() => handelSelectedTasks(index)}></input>
                  </div>
                  <div className={styles.taskDescription}>
                    <div className={styles.name}>{element.taskDescription}</div>
                    <div className={styles.taskTags}>
                      <div className={styles.taskTags1}>
                        <div className={styles.tagDate}>{new Date(element.taskPlanningDate).toLocaleDateString()}</div>
                        <div className={element.taskDoDate && styles.tagDate}>{element.taskDoDate && new Date(element.taskDoDate).toLocaleDateString()}</div>
                      </div>
                      <div className={styles.taskTags2}>
                        <div className={styles.tags}>{element.taskProfessionalId && `${element.taskProfessionalId.professionalName} ${element.taskProfessionalId.professionalLastName1} ${element.taskProfessionalId.professionalLastName2}`}</div>
                        <div className={styles.tags}>{element.taskAreaId && element.taskAreaId.areaName}</div>
                        <div className={styles.tags}>
                          {
                            element.taskLabelId && element.taskLabelId.map(element => {
                              return <span>{element.labelName} </span>
                            })
                          }
                        </div>
                        <div className={styles.columnActions}>
                          <Link to={url}><i className="fa-solid fa-pen-to-square"></i></Link>
                          <Link to={url2} state={{ id: element._id, professional: element.taskProfessionalId, taskName: element.taskDescription }}><i class="fa-solid fa-square-plus"></i></Link>
                          <i className="fa-solid fa-trash" onClick={handleDesactive}></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }) : null
          }

        </div>
      </div>
    </div>
  )
}

export default Seguiments
